var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateQuestionnaire(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 513393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 513265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.125 7.875C9.125 6.83947 9.9645 6 11 6C12.0355 6 12.875 6.83947 12.875 7.875C12.875 8.56245 12.505 9.1635 11.9534 9.4899C11.478 9.7711 11 10.1977 11 10.75V12",
    stroke: "#426CFF",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.1 15C11.1 15.0552 11.0552 15.1 11 15.1C10.9448 15.1 10.9 15.0552 10.9 15C10.9 14.9448 10.9448 14.9 11 14.9C11.0552 14.9 11.1 14.9448 11.1 15Z",
    fill: "#5B6B79",
    stroke: "#426CFF",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21 11C21 15.714 21 18.0711 19.5355 19.5355C18.0711 21 15.714 21 11 21C6.28595 21 3.92893 21 2.46447 19.5355C1 18.0711 1 15.714 1 11C1 6.28595 1 3.92893 2.46447 2.46447C3.92893 1 6.28595 1 11 1C15.714 1 18.0711 1 19.5355 2.46447C20.5093 3.43821 20.8356 4.80655 20.9449 7",
    stroke: "#426CFF",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1250",
    cx: 23,
    cy: 20,
    r: 6,
    fill: "#43C3FA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateQuestionnaire);
export default __webpack_public_path__ + "static/media/create-questionnaire.f41638286ea161db8919cb27f771e5b3.svg";
export { ForwardRef as ReactComponent };